import { SESSION_STORAGE_OVERRIDE_TOKEN } from './config';

export const store = {
  get() {
    return (
      window.sessionStorage.getItem(SESSION_STORAGE_OVERRIDE_TOKEN) ?? undefined
    );
  },
  set(token: string) {
    window.sessionStorage.setItem(SESSION_STORAGE_OVERRIDE_TOKEN, token);
  },
  remove() {
    window.sessionStorage.removeItem(SESSION_STORAGE_OVERRIDE_TOKEN);
  },
};
